import { Element } from '../../../common/html/element'
import { OVERVIEW_KEYS, OVERVIEW_KEY_COUNT_PER_BOX } from '../constant'
import classes from './index.module.scss'
import { InfoItem } from './InfoItem'
import { MapItem } from './MapItem'

export const Overview = ({ isDynamicReport }) => {
  return (
    <Element className="dFlex flexWrap">
      {OVERVIEW_KEY_COUNT_PER_BOX.map((count, index) => {
        const isMapBox = index === OVERVIEW_KEY_COUNT_PER_BOX.length - 1
        const startKeyIndex = OVERVIEW_KEY_COUNT_PER_BOX.reduce(
          (prevVal, currVal, currIndex) =>
            currIndex < index ? prevVal + currVal : prevVal,
          0,
        )
        const endKeyIndex = startKeyIndex + count

        if (isMapBox && isDynamicReport) return null

        return (
          <Element
            key={index}
            className={classes.box}
            style={{
              width: isDynamicReport
                ? 'calc(100% / 2)'
                : isMapBox
                ? 'calc(100% / 3 * 2)'
                : 'calc(100% / 3)',
              borderColor: '#D5D5D5',
              color: '#3A414B',
              padding: isMapBox ? 0 : '10px 12px',
            }}
          >
            {Object.keys(OVERVIEW_KEYS)
              .slice(startKeyIndex, endKeyIndex)
              .map((dataKey) => {
                if (OVERVIEW_KEYS[dataKey] === OVERVIEW_KEYS.MAP) {
                  return <MapItem key={dataKey} />
                }

                return (
                  <InfoItem key={dataKey} dataKey={dataKey} isDynamicReport />
                )
              })}
          </Element>
        )
      })}
    </Element>
  )
}
